import { Organization, Tenant } from './api';

// Map an organization_id to its display name, falling back to the id.
export const resolveOrganizationName = (orgs: Organization[], organizationId: string): string => {
  const org = orgs.find(o => o.id === organizationId);
  return org?.name || organizationId;
};

// Get organizations that are not already used by other tenants
export const getAvailableOrganizations = (
  organizations: Organization[],
  tenants: Tenant[],
  excludeTenantId?: string
): Organization[] => {
  const usedOrgIds = new Set(
    tenants
      .filter(t => !excludeTenantId || t.tenant_id !== excludeTenantId)
      .map(t => t.organization_id)
  );
  return organizations.filter(org => !usedOrgIds.has(org.id));
};
